import { render, staticRenderFns } from "./ContentFeedCover.vue?vue&type=template&id=7cd7eb9d&"
import script from "./ContentFeedCover.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedCover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports